import type { ReactNode } from 'react';
import { cx } from '../../utils';
import styles from './CdPublicTemplate.module.scss';

export interface CdPublicSectionProps {
  /** Full-bleed sections (hero) span the whole width; others get the page gutter. */
  bleed?: boolean;
  children: ReactNode;
  className?: string;
}

/** Content band inside `PublicTemplate`, applying the responsive page gutter. */
export const CdPublicSection = ({ bleed = false, children, className }: CdPublicSectionProps) => {
  return <div className={cx(!bleed && styles.gutter, className)}>{children}</div>;
};
